const ACTIONS = {
    SET_NUM_CELULAR: 'SET_NUM_CELULAR',
    SET_NUM_TELEFONE: 'SET_NUM_TELEFONE'
};
const INITIAL_STATE = {
    numCelular: '',
    numTelefone: ''
};
export function ContatoReducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case ACTIONS.SET_NUM_CELULAR:
            return {
                ...state,
                numCelular: action.numCelular
            };
        case ACTIONS.SET_NUM_TELEFONE:
            return {
                ...state,
                numTelefone: action.numTelefone
            };
        default:
            return state;
    }
}
